export const USER = 'ATC_Renuevo'
export const PASS = 'vtY9sJEO9oHF'
export const USER_STA = 'AONR177'
export const PASS_STA = '1234'
